import { createReducer, on } from '@ngrx/store';
import {Report} from "../../models/report.model";
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  clearReportState,
  downloadReport,
  downloadReportFailure,
  downloadReportSuccess,
  generateReport,
  generateReportFailure,
  generateReportSuccess,
  loadReports,
  loadReportsFailure,
  loadReportsSuccess,
  loadReportValidationMessages, loadReportValidationMessagesFailure,
  loadReportValidationMessagesSuccess,
  removeReport,
  removeReportFailure,
  removeReportSuccess, setReportValidationMessages
} from "./report.action";
import {ValidationMessage} from "../../../shared/models/cad-model.model";
import {Message} from "../../../shared/models/message.model";

export interface ReportState {
  reports: Report[];
  latestReportValidationMessages: Message[];
  error: string | null;
  status: StateStatus;
  downloadReportStatus: StateStatus;
  reportValidationMessageStatus: StateStatus;
}

export const initialState: ReportState = {
  reports: [],
  latestReportValidationMessages: [],
  error: null,
  status: 'pending' as StateStatus,
  downloadReportStatus: 'pending' as StateStatus,
  reportValidationMessageStatus: 'pending' as StateStatus,
};

export const reportReducer = createReducer(
  initialState,
  on(loadReports, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(clearReportState, (state) => ({
    ...state,
    reports: [],
    error: null,
    status: 'pending' as StateStatus,
    downloadReportStatus: 'pending' as StateStatus,
    reportValidationMessageStatus: 'pending' as StateStatus,
  })),
  on(loadReportsSuccess, (state, { reports }) => ({
    ...state,
    reports: reports,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(loadReportsFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),
  on(generateReport, (state) => ({ ...state, status: 'generating' as StateStatus })),
  on(generateReportSuccess, (state, { generateStatus }) => ({
    ...state,
    error: null,

    status: 'generateSuccess' as StateStatus,
  })),
  on(generateReportFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'generateError' as StateStatus,
  })),
  on(downloadReport, (state) => ({
    ...state,
    downloadReportStatus: 'loading' as StateStatus,
  })),
  on(downloadReportSuccess, (state, { file }) => ({
    ...state,
    downloadReportStatus: 'loadSuccess' as StateStatus,
  })),
  on(downloadReportFailure, (state, { error }) => ({
    ...state,
    error: error,
    downloadReportStatus: 'loadError' as StateStatus,
  })),
  on(removeReport, (state, { reportId }) => ({
    ...state,
    status: 'removing' as StateStatus,
    reports: state.reports.filter(report => reportId !== report.id)
  })),
  on(removeReportSuccess, (state) => ({
    ...state,
    status: 'removeSuccess' as StateStatus,
  })),
  on(removeReportFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'removeError' as StateStatus,
  })),

  on(loadReportValidationMessages, (state) => ({ ...state, reportValidationMessageStatus: 'loading' as StateStatus })),
  on(loadReportValidationMessagesSuccess, (state: ReportState, { report }): ReportState => ({
    ...state,
    latestReportValidationMessages: report.validationMessages,
    reports: state.reports.map((reportWithOutMessages: Report) => {
      return reportWithOutMessages.id === report.id ? report : reportWithOutMessages;
    }),
    error: null,
    reportValidationMessageStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadReportValidationMessagesFailure, (state, { error }) => ({
    ...state,
    error: error,
    reportValidationMessageStatus: 'error' as StateStatus,
  })),

  on(setReportValidationMessages, (state: ReportState, { validationMessages }): ReportState => ({
    ...state,
    latestReportValidationMessages: validationMessages,
  })),
);
